import { Route } from 'react-router-dom';
import { pages } from '../../../utils/common';
import DashboardView from './dashboard.view';
import { ProtectedRoute } from '../../../components/rbac/ProtectedRoute';

const useDashboardRoutes = () => (
  <Route
    path={pages.dashboard.path}
    element={
      <ProtectedRoute module="dashboard" checkAnySubmodule>
        <DashboardView />
      </ProtectedRoute>
    }
  >
    <Route
      path={pages.dashboard.path + '/:dashboardSubRouteId'}
      element={
        <ProtectedRoute module="dashboard" checkAnySubmodule>
          <DashboardView />
        </ProtectedRoute>
      }
    />
  </Route>
);

export default useDashboardRoutes;
